// Filiais = contas do Tiny (empresa_id). Mesmo mapa do backend (config.FILIAL_NOMES).
export const FILIAIS_TINY = [[1, 'Matriz'], [2, 'Filial 2'], [3, 'Filial 5'], [4, 'Filial SP'], [5, 'Filial ES']];

const NOMES = Object.fromEntries(FILIAIS_TINY);

// Nome da filial pelo empresa_id — pedidos de frete grátis antigos não gravavam o nome.
export const nomeFilial = (empresaId) => NOMES[empresaId] || `Empresa ${empresaId}`;
